<script>
import { onDestroy } from 'svelte';
import { countdown } from './util';

export let endTime;
let parts;
let timer;

function updateCountdown() {
  timer?.unsubscribe()

  if (!endTime) return;

  timer = countdown(endTime).subscribe(timeleft => {
    parts = timeleft;
    parts.done && timer.unsubscribe();
  })
}

$: endTime, updateCountdown()

onDestroy(() => timer?.unsubscribe())
</script>

{#if !parts.done}
  {#if parts.days > 0}
    <span>{parts.days} <span class="unit">days</span> </span>
  {/if}

  {#if parts.hours > 0}
      <span>{parts.hours} <span class="unit">hrs</span> </span>
  {/if}

  {#if parts.hours > 0 || parts.minutes > 0}
    <span>{parts.minutes} <span class="unit">min</span> </span>
  {/if}

  {parts.seconds} <span class="unit">sec</span>
{/if}

<style>
.unit {
  font-size: 24px;
  font-weight: 300;
}
</style>